/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/createIntegrationConfigurationOverrides';

export type CreateIntegrationConfigurationPathParams = NonNullable<
  operations['createIntegrationConfiguration']['parameters']['path']
>;

export type CreateIntegrationConfigurationRequestBody = OperationRequestBodyContent<
  operations['createIntegrationConfiguration']
>;

export interface Input extends CreateIntegrationConfigurationPathParams {
  apiVersion?: string;
  body: CreateIntegrationConfigurationRequestBody;
}

export async function createIntegrationConfiguration(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/integration-configurations/keys/{integrationKey}', {
    params: { path },
    body,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
